import '../../css/base.css';
import Home from './home';
import Welcome from './welcome';
import YourStayContainer from '../yourstay/yourStayContainer';
import DirectBooking from '../booking/directBookings';
import YourParty from '../booking/yourParty';
import { YourDetails } from '../booking/yourDetails';
import ReviewBooking from '../booking/reviewBooking';
import Location from './location';
import Gallery from './gallery';
import Activities from '../activities/activities';
import EatingOut from './eatingout';
import Reviews from './reviews';
import Contact from './contact';
import CheckoutComposite from '../booking/checkoutComposite';
import PaymentSuccess from '../booking/paymentSuccess';
import TermsAndConditions from '../booking/termsAndConditions';
import BookingError from '../booking/bookingError';
import { useSelector } from 'react-redux';

const MainContent = () => {

  const appstate = useSelector((state) => state.appState);

  let pageName = <Home />;

  switch (appstate.page) {
    case "HOME":
      pageName =  <Home />;
      break;
    case "WELCOME":
      pageName =  <Welcome />;
      break;    
    case "YOUR_STAY":
        pageName =  <YourStayContainer />;
        break;            
    case "BOOKING":
        pageName =  <DirectBooking />;
        break;
    case "YOUR_PARTY":
        pageName =  <YourParty />;
        break;
    case "YOUR_DETAILS":
        pageName =  <YourDetails />;
        break;
    case "REVIEW_BOOKING":
        pageName =  <ReviewBooking />;    
        break;
    case "PAYMENT":
        pageName =  <CheckoutComposite />;    
        break;
    case "TERMS_AND_CONDITIONS":
        pageName =  <TermsAndConditions />;    
        break;
    case "PAYMENT_SUCCESS":
        pageName =  <PaymentSuccess />;    
        break;
    case "BOOKING_ERROR":
        pageName =  <BookingError />;    
        break;
    case "LOCATION":
        pageName =  <Location />;
        break;
    case "GALLERY":
        pageName =  <Gallery />;
        break;
    case "ACTIVITIES":
        pageName =  <Activities />;
        break;
    case "EATING_OUT":
      pageName =  <EatingOut />;
      break;
    case "REVIEWS":
      pageName =  <Reviews />;
      break;
    case "CONTACT":
      pageName =  <Contact />;
      break;
    default:
      pageName = <Home />;
  }

  return (
    <div className="container-fluid">
      {pageName}
    </div>
  )

}

export default MainContent;